import axios from '../http'

function query(data) {
    return axios.post('/event/boatTransfer/query', data);
}

function get(id) {
    return axios.get('/event/boatTransfer/get?id=' + id);
}

function findRaceByProject(projectId) {
    return axios.get('/event/boatTransfer/findRaceByProject?projectId=' + projectId);
}

function add(data) {
    return axios.post('/event/boatTransfer/add', data);
}

export default {
    query,
    get,
    findRaceByProject,
    add
}